import script from "./VASearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./VASearch.vue?vue&type=script&setup=true&lang=ts"

import "./VASearch.vue?vue&type=style&index=0&id=b209f88a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b209f88a"]])

export default __exports__